module.exports = __webpack_public_path__ + "static/img/emoji_150.6d23655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emoji/emoji_150.png
// module id = vDP2
// module chunks = 6